import { ProjectSelector } from "@/components/ProjectSelector/ProjectSelector.tsx"
import { Page } from "@/routes/auth/Page.tsx"
import { PageBackgroundGradient } from "@/routes/auth/PageBackgroundGradient.ts"


export const HomeScene = () => {
  return (
    <Page backgroundGradient={PageBackgroundGradient.Home}>
      <ProjectSelector />
    </Page>
  )
}